import React from "react";
import TextDivider from "../SVG/TextDivider1";
import FancyBorder from "./FancyBorder";
import * as styles from "../../styles/menu/menuBrowse.module.css";
import Tree from "./Tree";

function MenuBrowse({ data, className, onNameClickFunc, height }) {
  return (
    <FancyBorder height={height}>
      <div className={`${styles.container} ${className}`}>
        <TextDivider fill="#d19851" className={styles.head}>
          Quick Browse
        </TextDivider>
        {data.map((course, index) => {
          return (
            <span key={index}>
              <Tree
                nameClick={onNameClickFunc}
                number={course.menuInfo.length}
                fill="#d19851"
                className={styles.courseName}
                name={`${course.courseName}`}
                defaultOpen
              >
                {course.menuInfo.map((menuItem, index) => {
                  return (
                    <span key={index}>
                      <Tree
                        nameClick={onNameClickFunc}
                        number={menuItem.products.length}
                        fill="#d19851"
                        className={styles.menuName}
                        name={`${menuItem.menuCategory}`}
                      >
                        {menuItem.products.map((product, index) => {
                          return (
                            <span key={index}>
                              <Tree
                                nameClick={onNameClickFunc}
                                fill="#d19851"
                                className={styles.productName}
                                name={`${product.name}`}
                              />
                            </span>
                          );
                        })}
                      </Tree>
                    </span>
                  );
                })}
              </Tree>
            </span>
          );
        })}
      </div>
    </FancyBorder>
  );
}

export default React.memo(MenuBrowse);
